<template>
  <div class="v-subscription-info-modal">
    <div class="modal-backdrop">
      <div class="modal">

        <header class="modal-header">
          <slot name="header">
            <h5>Информация о подписке</h5>
            <button type="button" class="btn-close" @click="close">x</button>
          </slot>
        </header>

        <section class="modal-body">
          <slot name="body">
            <div class="row px-3">
              <div class="col-6 pb-3">
                <h5>SIM карта</h5>
                Номер телефона SIM карты: {{ subscription.sim_card.phone_number }}<br>
                Серийный номер SIM карты: {{ subscription.sim_card.new_serial_number }}<br>
                Диллер SIM карты: {{ subscription.sim_card.dealer
                ? subscription.sim_card.dealer.last_name : 'Без дилера' }}<br>
                Дата активации SIM карты: {{ subscription.sim_card.activation_date }}<br>
                PUC код: {{ subscription.sim_card.puk_code }}<br>
                Оператор: {{ subscription.sim_card.provider.name }}<br>
                <span v-if="subscription.sim_card.provider_agent">
                  Поставщик: {{ subscription.sim_card.provider_agent.name }}<br>
                </span>
                Пароль ЛК оператора: {{ subscription.sim_card.lk_psw }}<br>
                Комментарий: {{ subscription.sim_card.comment }}<br>
              </div>

              <div class="col-6 pb-3">
                <h5>Подписка</h5>
                Дата активации подписки: {{ fixDateAndTine(subscription.created_at) }}<br>
                Тариф: {{ subscription.tariff.name }}<br>
                Тариф(внутреннее название): {{ subscription.tariff.internal_name }}<br>
                Тариф(код из 1с): {{ subscription.tariff.code_from_1c }}<br>
                День оплаты: {{ subscription.payment_day }}<br>
                Комментарий: {{ subscription.internal_comment }}<br>

                 <h5 class="pt-3">Подписчик</h5>
                Ф.И.О.:
                {{ subscription.subscriber.last_name }}
                {{ subscription.subscriber.first_name }}
                {{ subscription.subscriber.middle_name }}
                <br>
                Телефон подписчика: {{ subscription.subscriber.contact_phone }}<br>
                Адрес подписчика:
                город: {{ subscription.subscriber.passport.city }},
                улица: {{ subscription.subscriber.passport.street }},
                дом: {{ subscription.subscriber.passport.home }},
                квартира: {{ subscription.subscriber.passport.apartment }}
                <br>
                Баланс подписчика: {{ subscription.subscriber.balance }}<br>
              </div>
            </div>
          </slot>
        </section>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'v-subscription-info-modal',
  props: ['subscription'],
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
